import axios from "axios";
import {
  ResponseFile,
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {
  EQSpecification,
  EquipmentListParams,
  ReliabilityParams,
} from "../../models/serverModels/equipment/EQSpecification";

const rootApi = process.env.REACT_APP_API_KEY;

const specification = axios.create({
  baseURL: rootApi,
});

export const getList = async (
  params: EquipmentListParams
): Promise<ResponseList<EQSpecification>> =>
  specification({
    url: "/EquipmentList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EQSpecification>> =>
  specification({
    url: `/Equipment/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (
  params: Params.Create<EQSpecification>
): Promise<ResponseItem<EQSpecification>> =>
  specification({
    url: `Equipment`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  specification({
    url: `/Equipment/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<EQSpecification>
): Promise<ResponseItem<EQSpecification>> =>
  specification({
    url: `/Equipment/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);

export const reliabilityList = async (
  params: ReliabilityParams
): Promise<ResponseList<EQSpecification>> =>
  specification({
    url: "/Reliability",
    method: "get",
    params,
  }).then((res) => res.data);

export const importEquipments = async (params: Params.ImportFile): Promise<ResponseFile> =>
  specification({
    url: `/ImportEquipments`,
    method: "post",
    data: params,
  }).then((res) => res.data);
